import tmhRequest from '@/config/tmhRequest'

export default {

    searchListSchedulingClassify: function (data) {
        return tmhRequest({
            url: '/baseinfo/tmh/schedulingclassify/searchlistschedulingclassify',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/baseinfo/schedulingclassify.js